import Header from "./components/Header";
import Calculator from "./components/Calculator";
import "./index.css";
import Footer from "./components/Footer";
function App() {
  return (
    <div>
      <Header />
      <Calculator />
      <Footer />
    </div>
  );
}

export default App;
